import {TranslatableCellFieldProps, SoftCapProps, HardCapProps} from './types';

export function isSoftCapProps(
  TranslatableCellFieldProps?: TranslatableCellFieldProps,
): TranslatableCellFieldProps is SoftCapProps {
  return (
    (TranslatableCellFieldProps as SoftCapProps)?.suggestedLength !== undefined
  );
}

export function isHardCapProps(
  TranslatableCellFieldProps?: TranslatableCellFieldProps,
): TranslatableCellFieldProps is HardCapProps {
  return (TranslatableCellFieldProps as HardCapProps)?.maxLength !== undefined;
}
